<template>
  <div class="block">
    <el-carousel trigger="click" height="660px">
      <el-carousel-item v-for="item in 4" :key="item">
        <img src="../../static/img/banner.jpg" />
      </el-carousel-item>
    </el-carousel>
    <div class="content">
      <div>
        <h2>
          <img
            class="smallLogo"
            src="../../static/img/logo.png"
          />会员服务技术解决方案提供商
        </h2>
        <p>
          上海富惠网络有限公司（Link2shops）是国内领先的会员服务系统解决方案提供商，专注于面向机构提供包括会员系统、风控反欺诈、智能聚合收银台等技术解决方案。目前服务的机构包括Visa、工行、农行、中行、建行、平安、中信、广发、招行等，提供的会员服务应用范围覆盖数字产品、零售餐饮、跨境电商等领域，合作伙伴涉及中国、日本、韩国、新加坡、泰国等国家近300个品牌超过8000个门店。
Link2shops总部位于上海，在北京、香港、东京等地设立有子公司、分公司或办事处，并在武汉设有云计算研发中心。
        </p>
        <div class="mode-list">
          <dl>
            <dt>
              <span class="mode-list-icon"
                ><img src="../../static/img/icon_1.png"
              /></span>
            </dt>
            <dd>
              <h3>一站式解决方案</h3>
              <span>分销服务<br />预订服务<br />支付/收款<br />推广服务</span>
            </dd>
          </dl>
          <dl>
            <dt>
              <span class="mode-list-icon"
                ><img src="../../static/img/icon_2.png"
              /></span>
            </dt>
            <dd>
              <h3>全方位服务</h3>
              <span>
                提供系统和软件，提高业务效率<br />
                提供专属商户运营经理，帮助商户处理业务，响应商户要求<br />
                提供客服中心，及时解决处理个人客户在购买过程中的问题<br />
                提供数据分析报告，为商户提供市场推广、产品服务等建议
              </span>
            </dd>
          </dl>
          <dl>
            <dt>
              <span class="mode-list-icon"
                ><img src="../../static/img/icon_3.png"
              /></span>
            </dt>
            <dd>
              <h3>定制化</h3>
              <span>
                定制化服务：根据商户需求，提供定制化的服务或系统<br />
                定制化渠道：提供符合商户特点和目标的渠道<br />
                定制化策略：结合商户特点，综合时间、地域、目标客户、渠道等因<br />
                素，为商户提供针对性的市场推广或营销建议
              </span>
            </dd>
          </dl>
          <dl>
            <dt>
              <span class="mode-list-icon"
                ><img src="../../static/img/icon_4.png"
              /></span>
            </dt>
            <dd>
              <h3>渠道资源丰富</h3>
              <span>
                与中国国内外超过40家知名OTA（在线旅行社）、银行、航空公司等<br />
                有合作，是多家知名企业集团的海外权益服务指定提供单位
              </span>
            </dd>
          </dl>
        </div>
        <div class="company">
          <div class="line-block">
            <div>合作伙伴</div>
          </div>
          <ul class="company-logo">
            <div class="side left">
              <div class="companyType">金融机构</div>
              <li><img src="../../static/img/logo/l_1.png" /></li>
              <li><img src="../../static/img/logo/l_2.png" /></li>
              <li><img src="../../static/img/logo/l_3.png" /></li>
              <li><img src="../../static/img/logo/l_4.png" /></li>
              <li><img src="../../static/img/logo/l_5.png" /></li>
              <li><img src="../../static/img/logo/l_6.png" /></li>
            </div>
            <div class="side right">
              <div class="companyType">商户</div>
              <li><img src="../../static/img/logo/l_7.png" /></li>
              <li><img src="../../static/img/logo/l_8.png" /></li>
              <li><img src="../../static/img/logo/l_9.png" /></li>
              <li><img src="../../static/img/logo/l_10.png" /></li>
              <li><img src="../../static/img/logo/l_11.png" /></li>
              <li><img src="../../static/img/logo/l_12.png" /></li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>
<style type="text/css">
.el-carousel__arrow {
  width: 40px;
  height: 40px;
  line-height: 40px;
  background-color: rgba(0, 0, 0, 0.3);
}
.el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
.el-carousel__indicators {
  bottom: 50px;
}
.el-carousel__button {
  background-color: #fff;
  height: 6px;
}
.el-carousel__indicator .is-active {
  background-color: #33569a;
}
.content {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
}
.content .smallLogo {
  vertical-align: middle;
  width: 150px;
  height: 30px;
  margin-right: 10px;
}
.content h2 {
  font-size: 24px;
  line-height: 40px;
  margin-bottom: 20px;
}
.content p {
  font-size: 14px;
  text-align: left;
  line-height: 26px;
}
.mode-list {
  width: 100%;
  float: left;
  margin: 50px 0;
}
.mode-list dl {
  width: 50%;
  float: left;
  text-align: left;
  margin-bottom: 40px;
}
.mode-list dt,
.mode-list dd {
  float: left;
  font-size: 14px;
  line-height: 26px;
}
.mode-list-icon {
  background-color: #244893;
  width: 60px;
  height: 60px;
  display: inline-block;
  text-align: center;
  margin-right: 30px;
}
.mode-list-icon img {
  height: 40px;
  margin-top: 10px;
}
.mode-list dd h3 {
  font-size: 14px;
  line-height: 40px;
}
.company {
  width: 100%;
  float: left;
}
.line-block {
  position: relative;
  font-size: 24px;
  font-weight: bold;
}
.line-block div:before,
.line-block div:after {
  position: absolute;
  background: #ccc;
  content: "";
  height: 1px;
  top: 50%;
  width: 42%;
}
.line-block div:before {
  left: 10px;
}
.line-block div:after {
  right: 10px;
}
.company-logo {
  width: 100%;

  display: flex;
  justify-content: space-between;
  margin: 30px 0;
}
.company-logo .side {
  width: 480px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.company-logo .companyType {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  width: 100%;
}
.company-logo li {
  min-width: 240px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.company-logo li img {
  /* width: 195px;
  height: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue